import React, { Component, createRef } from "react";
import "component/listItem/CategoryType9/styles.scss";
import iconDefault from "assets/images/iconDefault.png";
import { PlayDesktopIcon } from "component/icons";
import { ReactComponent as CrownIcon } from "assets/icons/Jackpot.svg";
import { ReactComponent as TrophyIcon } from "assets/icons/Tournament.svg";
import { ReactComponent as RibbonIcon } from "assets/icons/FreeRounds.svg";
import { ReactComponent as EditorsChoiceIcon } from "assets/icons/editors-badge.svg";
import { setDefaultImageFormat } from "utils/image";
import { getTotalPool } from "utils/getTotalpool";

const ICON_DEFAULT = "ICON_DEFAULT";

class Category extends Component {
  constructor(props) {
    super(props);
    this.onMouseOverHandler = this._onMouseOverHandler.bind(this);
    this.mainComponent = createRef();
    this.getTotalPool = getTotalPool.bind(this);
    this.state = {
      hovered: false,
      jackpotPool: null,
    };
  }

  _onMouseOverHandler(bol) {
    this.setState({
      hovered: bol,
    });
  }

  componentDidMount() {
    this.initObserver();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.props.game.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.state.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.mainComponent.current) {
                this.setState({
                  isVisible: true,
                });
              }
            } else {
              if (this.mainComponent.current) {
                //clearInterval(this.initLoadDelay)
              }
            }
          });
        },
        {
          //rootMargin: '500px 0px 500px 0px'
          rootMargin: "0px 0px 0px 0px",
        }
      );
      observer.observe(this.mainComponent.current);
    } else {
      //this.getGames(this.props.link);
      //this.getTournamentPreview(this.props.links)
    }
  }
  renderSkeleton() {
    return <div>testing</div>;
    /* return (
      <div className="related-category">
        <img
          ref={BANNER_DEFAULT}
          src={defaultBanner}
          className="img-fluid w-100"
          alt=" "
        />
        <div className="labelRow">
          <span className="label">
            <div className="name">
              <span className="dummy">XXXXXXXXXXXXX</span>
            </div>
            <div className="provider">
              <span className="dummy">XXXXXXXXXXXXX</span>
            </div>
            <div className="game-type">
              <span className="dummy">XXXXXXXXXXXXX</span>
            </div>
          </span>
        </div>
      </div>
    ); */
  }

  render() {
    let { game } = this.props;

    return (
      <div
        className={`${
          this.props.className ? this.props.className : ""
        } category-type-9`}
        onMouseOver={() => {
          this.onMouseOverHandler(true);
        }}
        onMouseOut={() => {
          this.onMouseOverHandler(false);
        }}
        onClick={() => {
          if (this.props.onClick) {
            this.props.onClick(this.props.linkDetail.get("rel"));
          }
        }}
        ref={this.mainComponent}
      >
        <div>
          {game && game.get("jackpotBalance") && (
            <div className="jackpot-amount">
              {this.getTotalPool(this.state.jackpotPool, game, false)}
            </div>
          )}
          {game && this.state.isVisible && (
            <img
              src={`${setDefaultImageFormat(
                game
                  .getIn(["images", "iconUrl"])
                  .replace("width=90", "width=200") + "&theme=dark",
                this.props.imageFormat.get("logoRound")
              )}`}
              className="icon d-none"
              alt={game.get("name")}
              onLoad={({ currentTarget }) => {
                currentTarget.classList.remove("d-none");
                this.refs[ICON_DEFAULT].classList.add("d-none");
              }}
            />
          )}
          <img
            ref={ICON_DEFAULT}
            src={iconDefault}
            className="icon"
            alt="banner"
          />
          <div className="details h-100 d-flex align-items-center">
            {game && (
              <div>
                <div className="name">{game.get("name")}</div>
                <div className="provider">{game.get("provider")}</div>
                <div className="game-type">
                  {game.get("gameType") ? game.get("gameType") : null}
                </div>
              </div>
            )}
            {!game && (
              <div>
                <div className="name">
                  <span className="dummy">XXXXXXXXXX</span>
                </div>
                <div className="provider">
                  <span className="dummy">XXXXXXXXXX</span>
                </div>
                <div className="game-type">
                  <span className="dummy">XXXXXXXXXX</span>
                </div>
              </div>
            )}
            {game && (
              <span className="game-feature-badge">
                {game.get("hasFreeRounds") && (
                  <span className="ribbonIcon">
                    <RibbonIcon color="rgba(255, 204, 0, 1)" />
                  </span>
                )}
                {game.get("partOfOnGoingTournament") && (
                  <span className="trophyIcon">
                    <TrophyIcon color="rgba(255, 204, 0, 1)" />
                  </span>
                )}
                {game.get("isJackpot") && (
                  <span className="jackpotIcon">
                    <CrownIcon color="rgba(255, 204, 0, 1)" />
                  </span>
                )}
                {game.get("isFeatured") && (
                  <span className="editorsChoiceIcon">
                    <EditorsChoiceIcon color="rgba(255, 204, 0, 1)" />
                  </span>
                )}
              </span>
            )}
            {game && (
              <div className="game-type">
                {game.get("gameType") ? null : <>&nbsp;</>}
              </div>
            )}
          </div>
          {game && !this.props.isMobile && !this.props.isOneClickPlayEnabled && (
            <div
              className={`actions row w-100 justify-content-center align-items-center ${
                this.state.hovered ? "" : "d-none"
              }`}
            >
              <div className="col">
                {this.props.linkReal && (
                  <div
                    className="play-button text-center"
                    onClick={(event) => {
                      if (this.props.onClick) {
                        this.props.onClick(this.props.linkReal.get("rel"));
                      }
                      event.stopPropagation();
                    }}
                  >
                    <PlayDesktopIcon />
                  </div>
                )}
                {this.props.linkDemo && (
                  <div className="demo-button">
                    <button
                      className="btn btn-secondary btn-xs"
                      onClick={(event) => {
                        if (this.props.onClick) {
                          this.props.onClick(this.props.linkDemo.get("rel"));
                        }
                        event.stopPropagation();
                      }}
                    >
                      {this.props.linkDemo.get("name")}
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Category;
